<template>
    <div class="paper-box">
        <div class="top-box">
            <div class="top-content">
                <div class="paper-ev">
                    <div class="paper-name">{{ detail.testPaperName || '暂无' }}</div>
                    <div class="paper-base">
                        <div class="top-item">
                            <p>创建人：</p>
                            <p>{{ detail.createName || '暂无' }}；</p>
                        </div>
                        <div class="top-item">
                            <p>创建院校：</p>
                            <p>{{ detail.institutions || '暂无' }}；</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-content">
                <div class="show-box-ev">
                    <div class="right-item">
                        <p>满分：</p>
                        <p>{{ detail.totalPoints || 0 }}</p>
                    </div>
                    <div class="right-item">
                        <p>总题量：</p>
                        <p>{{ detail.totalQuestionCount || 0 }}</p>
                    </div>
                    <div class="right-item" v-for="(item,index) in detail.questionDetailVOS||{}" :key="index">
                        <p>{{ index }}：</p>
                        <p>{{ item?item.length:0 }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-box">
            <div class="sub-module-item" v-for="(item, index) in detail.questionDetailVOS && detail.questionDetailVOS"
                :key="index">
                <div class="module-top">
                    <p>{{ numberToChinese(item.orderIndex) + '、' }}</p>
                    <p>{{ index }}</p>
                    <p>{{ `（共${item.length || 0}题，每题${item[0] ? item[0].questionScore : 0}分）` }}</p>
                </div>
                <div class="module-content">
                    <div class="content-item" v-for="(el, k) in item && item" :class="{ 'border-none': k == item.length - 1 }"
                        :key="k">
                        <div class="el-top">
                            <div>{{ k + 1 + '.' }}</div>
                            <div v-html="el.questionStem" class="html-box"></div>
                        </div>
                        <div v-if="index == '填空题'">
                            <div v-for="(e, i) in el.questionOptionVOS" :key="i"
                                style="display: flex;margin-top: 2rem;align-items: center;">
                                <div>{{ alphabet[i] + '：' }}</div>
                                <el-input v-model="e.value" style="width: 10rem;"></el-input>
                            </div>
                        </div>
                        <div class="options-box" v-else>
                            <el-radio-group v-model="el.value" v-if="['判断题', '单选题'].includes(index)">
                                <el-radio v-for="(e, i) in el.questionOptionVOS" :key="i" :label="e.id">
                                    <div style="display: flex;">
                                        <div>{{ alphabet[i] + '.' }}</div>
                                        <div v-html="e.content" style="white-space: var(--lineWrap);"></div>
                                    </div>
                                </el-radio>
                            </el-radio-group>
                            <el-checkbox-group  v-model="el.value" v-else-if="index == '多选题'">
                                <el-checkbox v-for="(e, i) in el.questionOptionVOS" :key="i" :label="e.id">
                                    <div style="display: flex;">
                                        <div>{{ alphabet[i] + '.' }}</div>
                                        <div v-html="e.content" style="white-space: var(--lineWrap);"></div>
                                    </div>
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GetTestPaperQuestion,GetUserAnswerRecord  } from '@/api/paper';
import { secondToHours } from '@/utils/utils';
import { numberToChinese } from '@/utils/utils';
export default {
    props:{
        examineId:{
            default:''
        }
    },
    data() {
        return {
            numberToChinese,
            paperId: '',
            alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
            detail: {},
            recordId:'',
        }
    },
    methods: {
        secondToHours,
        /**返回 */
        toBack(){
            this.$router.go(-1);
        },
         /**获取用户答题记录 */
         getUserAnswerRecord() {
            var params = {
                "businessId": this.examineId?(this.paperId+'-'+this.examineId):this.paperId,
                "testPaperId": this.paperId,
                "testPaperSource": 'view_paper'
            }
            GetUserAnswerRecord(params).then(async(res) => {
                if (res.code == 200) {
                    this.recordId=res.data.id;
                    this.getTestPaperQuestion();
                }
            })
        },
        /**获取试卷题目数据 */
        getTestPaperQuestion() {
            return new Promise(resolve => {
                var params={
                    "businessId":this.examineId?(this.paperId+'-'+this.examineId):this.paperId,
                    "testPaperId":this.paperId,
                    "testPaperRecordId":this.recordId
                }
                GetTestPaperQuestion(params).then(res => {
                    if (res.code == 200) {
                        var questionDetailVOS = res.data.questionDetailVOS;
                        var i = 1;
                        for (let key in questionDetailVOS) {
                            questionDetailVOS[key].orderIndex = i;
                            i++;
                            questionDetailVOS[key] && questionDetailVOS[key].forEach(item => {
                                if (key == '多选题') {
                                    item.value = [];
                                    return;
                                } else if (key == '填空题') {
                                    item.questionOptionVOS && item.questionOptionVOS.forEach(el => {
                                        el.value = '';
                                    })
                                } else {
                                    item.value = '';
                                }
                            })
                        }
                        this.detail = res.data;
                        resolve(res.data);
                    }
                })
            })
        },
    },
    mounted(){
    }
}
</script>

<style lang="less" scoped>
.paper-box {
    position: relative;
    height: 100%;
    overflow: auto;
    .top-box {
        border: 1px solid #e2e4eb;
        padding: 4rem 2.5rem 2rem 2.5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        .top-img{
            position: absolute;
            right: 0;
            top: 0;
            width: 10.6rem;
            cursor: pointer;
        }
        .img-box-content{
            position: relative;
        .number{
            position: absolute;
            top: 0.5rem;
            left: 1.5rem;
            font-weight: 700;
            font-size: 3rem;
        }
        }
        .top-content{
            display: flex;
            .score-bg{
                width: 9rem;
            }
            .paper-ev{
                .paper-name{
                    font-weight: 700;
                    font-size: 2.4rem;
                    color: #000000;
                }
                .paper-base{
                    display: flex;
                    color: #8590B3;
                    .top-item{
                        display: flex;
                        margin-top: 0.2rem;
                    }
                }
            }
        }
        .bottom-content{
            display: flex;
            color: #8590B3;
            margin-top: 4rem;
            justify-content: space-between;
            .show-box-ev{
                display: flex;
                &> :nth-child(n){
                    margin-left: 1rem;
                }
                &> :nth-child(1){
                    margin-left: 0;
                }
                .right-item{
                    display: flex;
                    &> :nth-child(2){
                        color: var(--blue);
                    }
                }
            }
        }
    }
}
.operation-box{
    display: flex;
    align-items: center;
}
.module-top {
    height: 6rem;
    background: #f7f9ff;
    border: 1px solid #e8ecef;
    color: #334681;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    padding: 0 2.5rem;
}

.module-content {
    padding: 0 6rem;
    color: #334681;
    border: 1px solid #e8ecef;

    .content-item {
        padding: 3.5rem 0;
        border-bottom: 1px solid #e8ecef;
    }
}

.border-none {
    border-bottom: none !important;
}

.el-top {
    display: flex;
}

.html-box {
    white-space: var(--lineWrap);
}

.options-box {
    margin-top: 1.5rem;
}

/deep/.el-radio-group {
    display: flex;
    flex-direction: column;
}

/deep/.el-radio {
    margin-top: 2rem;
    display: flex;
}

/deep/.el-checkbox-group {
    display: flex;
    flex-direction: column;
}

/deep/.el-checkbox {
    margin-top: 2rem;
}

/deep/.el-input__inner {
    border: 1px solid transparent;
    border-bottom: 1px solid #334681;
    border-radius: 0;
}

.btn-box {
    display: flex;
    padding: 5rem 0;
    display: flex;
    justify-content: center;
}

.el-title {
    font-size: 2rem;
    color: #334681;
    font-weight: 700;
    text-align: center;
}

.el-view {
    color: #387DFF;
    text-align: center;
    margin-top: 2.5rem;
    margin-bottom: 5rem;
    cursor: pointer;
}

/deep/.el-dialog__header {
    display: flex;
    justify-content: center;
    font-weight: 700;
}

/deep/.el-dialog {
    border-radius: 1rem;
}

.answer-box {
    color: #334681;
    margin-top: 2rem;

    .box-item {
        display: flex;

        &> :nth-child(2) {
            color: var(--blue);
        }

        &> :nth-child(3) {
            margin-left: 1rem;
        }
    }
}

.an-item {
    display: flex;
    color: #334681;
    margin-top: 1rem;
}
.tip-box{
    .light{
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
        background-color: #FF2222;
        margin-right: 1rem;
    }   
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    height: 4rem;
    width: 25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #334681;
    position: fixed;
    top: 8.5rem;
    left: 50%;
    transform: translateX(-50%);
    background-color: #ffffff;
}
/deep/.el-input.is-disabled .el-input__inner{
    background-color: transparent;
    border-color: transparent;
    border-bottom: 1px solid #000000;
}
.icon-fanhui1{
    position: absolute;
    top: 15.2rem;
    left: 33rem;
    color: #000000;
    font-size: 2rem;
    cursor: pointer;
}
.dz{
    color: #FF4E00 !important;
}
.sc{
    color: rgb(247,186,42) !important;
}
/deep/.el-radio__label> :nth-child(1)> :nth-child(2){
    display: flex;
}
</style>